import { ContainerComponent, wrap } from 'AppReact';
import { Wrapper } from './wrappers';
import { SecondaryTextXs300, SecondaryTextSm, SecondaryTextXs } from 'atoms';
import Controller from './controller';
import { SolidButton } from 'molecules';
import { GenericWrapper, FlexBoxWrapper, SpanWrapper } from 'wrappers';
import { format } from 'date-fns';
import internalState from './internalState';

export const definition = {
  name: 'AdditionalOrderRow',
  controller: Controller,
  initialProps: ({ additionalOrder }) => ({ additionalOrder }),
  props: internalState,
  elements: [

    {
      wrapper: Wrapper,
      name: '__transparent__',
      elements: [
        {
          wrapper: GenericWrapper,
          name: 'InfoWrapper',
          elements: [
            {
              component: SecondaryTextXs300,
              name: 'Category',
              displayValue: ({ additionalOrder }) => additionalOrder.category ?? ''
            },
            {
              component: SecondaryTextSm,
              name: 'Label',
              displayValue: ({ additionalOrder }) => additionalOrder.subcategory ?? ''
            },
            {
              component: SecondaryTextXs,
              name: 'Status',
              displayValue: ({ additionalOrder }) => {
                let status = 'Unassigned';
                if (additionalOrder.status === 'assigned') {
                  status = 'Assigned'
                  if (additionalOrder.lastEvent?.event_name === 'assigned') {
                    status = additionalOrder.lastEvent.description;
                  } else if (additionalOrder.tech_name) {
                    return `Assigned to ${additionalOrder.tech_name}`
                  }
                }
                if (additionalOrder.status === 'completed') {
                  status = additionalOrder.completed_at ? `Completed on ${format(additionalOrder.completed_at, 'MM/dd/yyyy')}` : 'Completed';
                }
                if (additionalOrder.status === 'cancelled') {
                  status = `Canceled`
                }
                return status;
              }
            },
          ]
        },
        {
          component: wrap(wrap(SolidButton, SpanWrapper), FlexBoxWrapper),
          name: 'Button',
          bindings: ({ }) => ({ title: 'View' })
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);